import React from "react";
import { FaWarehouse } from "react-icons/fa";
import { Row, Col, Card, Spinner, Placeholder, Nav, Badge } from "react-bootstrap";
import _waitParts from "./_waitParts";
import apiEndPoints from "../../../../../componets/json/apiEndPoints.json";

class serviceSamsungWhs extends React.Component {

    state = {
        selectGroup: 0,
        waitParts: []
    }

    getWaitParts = async () => {
        const _res = await this.props._api({
            ...this.props,
            method: apiEndPoints.britex.internal.service.samsung.whs.waitParts.method,
            endpoint: apiEndPoints.britex.internal.service.samsung.whs.waitParts.endPoint,
            param: "",
        });
        this.setState({ loading: false });
        if (_res.status == 200) {
            this.setState({ waitParts: _res.data });
        }
    }

    componentDidMount() {
        this.props.setHeaderPage({
            Icon: <FaWarehouse className="c-placeholder c-green" />,
            Title: "SAMSUNG Sklad",
            SubTitle: "",
        });
        this.getWaitParts();
    }

    render() {
        return (
            <>
                <Row className="mb-4">
                    <Col>
                        <Nav variant="tabs" className="c-tab" defaultActiveKey={this.state.selectGroup}>
                            <Nav.Item>
                                <Nav.Link onClick={() => this.setState({ selectGroup: 0 })} eventKey="0">Čekající ND
                                    {this.state.waitParts != null && (
                                        <Badge bg="danger" className="ms-2">
                                            {this.state.waitParts.filter(e => e.matPO == null).length}
                                        </Badge>
                                    )}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link onClick={() => this.setState({ selectGroup: 6 })} eventKey="6">FIFO Chyby <Badge bg="danger" className="ms-1">3</Badge></Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link onClick={() => this.setState({ selectGroup: 1 })} eventKey="1">Objednávky</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link onClick={() => this.setState({ selectGroup: 2 })} eventKey="2">Dodávky</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link onClick={() => this.setState({ selectGroup: 3 })} eventKey="3">OFS Forecast</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link onClick={() => this.setState({ selectGroup: 4 })} eventKey="4">Dostupnost GSPN</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link onClick={() => this.setState({ selectGroup: 5 })} eventKey="5">Číselníky GSPN</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Col>
                </Row>
                {this.state.selectGroup == 0 && (
                    <_waitParts {...this.props} waitParts={this.state.waitParts} />
                )}
            </>
        )
    }
}
export default serviceSamsungWhs;